import type { ApiUpdateLastGamesPort } from './ports/api-update-last-games.port';
import type { LastGamesPostPayload } from '~/types/last-game';

export class UpdateLastGamesHandler {
  // eslint-disable-next-line no-useless-constructor
  constructor(private apiUpdateLastGamesPort: ApiUpdateLastGamesPort) {}

  async handle(payload: LastGamesPostPayload) {
    return await this.apiUpdateLastGamesPort.handle(payload);
  }
}
